export default __webpack_public_path__ + "static/landing-smh-logo-92a8a6dce30b780cbaaf66d3f2be14ad.png";